import "./double-slider.component.scss";

export default {
  template: require('./double-slider.component.html'),
  bindings: {
    left: "=vuiLeft",
    right: "=vuiRight",
    options: "<?vuiOptions",
    disabled: "@disabled",
    onChange: "<vuiChange",
  },
  controller: function ($element) {

    'ngInject';

    const self = this;

    self.$onInit = () => {
      if (!self.options) {
        self.options = {};
      }
      if (!self.options.min) {
        self.options.min = 0;
      }
      if (!self.options.max) {
        self.options.max = 100;
      }
      if (!self.options.step) {
        self.options.step = 1;
      }
      if (!self.left) {
        self.left = self.options.min + self.options.step;
      }
      if (!self.right) {
        self.right = self.options.max - self.options.step;
      }

      self.options.totalWidth = (self.options.max - self.options.min) / self.options.step;
      const leftValue = (self.left - self.options.min) / self.options.step;
      self.leftValue = (leftValue / self.options.totalWidth) * 100;
      const rightValue = (self.right - self.options.min) / self.options.step;
      self.rightValue = (rightValue / self.options.totalWidth) * 100;

      self.inited = true;

      $element.children().children().children()[1].value = self.left;
      $element.children().children().children()[2].value = self.right;
    }

    self.$onChanges = (changes) => {
      const leftValue = (self.left - self.options.min) / self.options.step;
      self.leftValue = (leftValue / self.options.totalWidth) * 100;
      const rightValue = (self.right - self.options.min) / self.options.step;
      self.rightValue = (rightValue / self.options.totalWidth) * 100;
    }

    self.onLeftChange = (e) => {
      if (self.disabled) {
        return;
      }

      const left = Math.round(self.left / self.options.step) * self.options.step;
      self.left = Math.min(left, self.right - self.options.step);
      const leftValue = (self.left - self.options.min) / self.options.step;
      self.leftValue = (leftValue / self.options.totalWidth) * 100;

      if (self.onChange) {
        self.onChange();
      }
    }

    self.onRightChange = (e) => {
      if (self.disabled) {
        return;
      }

      const right = Math.round(self.right / self.options.step) * self.options.step;
      self.right = Math.max(right, self.left - (-self.options.step));
      const rightValue = (self.right - self.options.min) / self.options.step;
      self.rightValue = (rightValue / self.options.totalWidth) * 100;

      if (self.onChange) {
        self.onChange();
      }
    }

    self.labelFormat = (value) => {
      if (self.options.translate) {
        return self.options.translate(value);
      }

      return value;
    }

    self.isOverlap = () => {
      return Math.abs(self.leftValue - self.rightValue) < 17;
    };

  }
};
